import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//
import ReactApexChart from "react-apexcharts";

function SmallChart({ data, last }) {
  const [key, setKey] = useState(0);
  const [option, setOption] = useState({
    series: [
      {
        name: "price",
        data: [],
      },
    ],
    chart: {
      type: "area",
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    dataLabels: {
      enabled: false,
    },

    stroke: {
      curve: "smooth",
      colors: ["#63e4b5"],
      width: 2,
    },

    xaxis: {
      //   type: "datetime",
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      tickAmount: 4,
      floating: false,

      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.1,
        opacityTo: 0.9,
        stops: [0, 99, 95],
        colors: ["#fff", "#e6fbf3", "#c7f5e5"],
      },
    },
    tooltip: {
      enabled: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        left: 0,
        right: 0,
      },
    },
  });

  useEffect(() => {
    let chart = { ...option };
    let series = [];

    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      series.push(+element.value);
    }

    chart.series[0].data = series;

    if (last < 0) {
      chart.stroke.colors = ["#F64A4A"];
      chart.fill.gradient.colors = ["#fff", "#fbe6e6", "#f5c7c7"];
    }

    setOption(chart);

    setKey(key + 1);

    // eslint-disable-next-line
  }, [data]);

  return (
    <ReactApexChart
      key={key}
      options={option}
      series={option.series}
      type="area"
      height={16}
      width={40}
    />
  );
}

SmallChart.propTypes = {
  data: PropTypes.array.isRequired,
  last: PropTypes.number.isRequired,
};

export default SmallChart;
